<template>
  <div class="view-container">
    <base-loader :loading="loadingContent">
      <div class="flex mb-5">
        <base-multiselect
          :hide-selected="true"
          :input-label="$t('projects.assignUsers')"
          :loading="loadingSelect"
          :max-height="200"
          :multiple="true"
          :options="users"
          :options-limit="20"
          @search-change="searchUsers"
          class="z-500"
          label="name"
          track-by="id"
          v-model="selectedAssignees"/>
        <base-button @click="assignSelectedUsers" class="self-center mt-5 p-3 ml-2" icon="plus"/>
      </div>

      <assignees-table :assignees="assigneesList"
                       :header="tableHeader"
                       @delete="removeAssigneePrompt"
                       class="z-10"/>
    </base-loader>
  </div>
</template>

<script>
  import AssigneesTable from "../../components/projects/AssigneesTable";
  import Users from "../../services/Users"
  import Projects from "../../services/Projects"

  export default {
    name: "UserConfig",
    components: {
      AssigneesTable
    },
    data: () => ({
      users: [],
      assigneesList: [],
      selectedAssignees: [],
      projectId: null,
      loadingSelect: false,
      loadingContent: false
    }),
    computed: {
      tableHeader () {
        return ([
          this.$t('users.table.name'),
          this.$t('users.table.surname'),
          this.$t('users.table.email'),
          this.$t('users.table.phone'),
          this.$t('users.table.role'),
          this.$t('users.table.actions')
        ])
      },
      formattedAssignees () {
        let newAssignees = this.selectedAssignees.map((el) => {
          return el.id;
        });
        return newAssignees
      }
    },
    methods: {
      getAssignees () {
        this.loadingContent = true
        Projects.getUsers(this.projectId).then(result => {
          this.assigneesList = result.data
        }).finally(() => this.loadingContent = false)
      },
      removeAssigneePrompt (id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('projects.removeAssigneeTitle'),
          text: this.$t('projects.removeAssigneeText'),
          accept: () => {
            this.removeAssignee(id)
          }
        });
      },
      removeAssignee (id) {
        let payload = {projectId: this.projectId, userId: id}
        Projects.removeUser(payload).then(() => {
          this.$notificationService.success(`${this.$t('users.user')} ${this.$t('notification.successRemoved')}`)
          this.getAssignees()
        }).catch(error => {
          this.$notificationService.error(error.message)
        })
      },
      searchUsers (query) {
        Users.list(query).then(result => {
          this.users = result.data
        })
      },
      assignSelectedUsers () {
        this.$vs.loading()
        let payload = {projectId: this.projectId, users: {ids: this.formattedAssignees}}
        Projects.addBulkUsers(payload).then(() => {
          this.getAssignees()
          this.selectedAssignees = []
          this.$notificationService.success(`${this.$t('modules.users')} ${this.$t('notification.successAssign')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.$vs.loading.close()
        })
      }
    },
    mounted () {
      this.projectId = this.$route.params.id
      this.getAssignees()
    }
  }
</script>

<style scoped>

</style>
